function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var module; // LICENSE_CODE ZON

'use strict';
/*jslint node:true, es6:true, react:true*/


var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['react', 'zutil', 'lodash.filter', 'hola_opt', '/util/url.js', '/www/hola/pub/pages_dict.js', '/util/events.js', '/www/hola/pub/util.js', '/svc/vpn/pub/common_ui.js', '/svc/account/pub/membership.js', '/util/string.js'], (React, _, _filter, hopt, zurl, pages_dict, events, www_util, common_ui, zmembership, zstring) => {
  var _E$all_plans;

  const qs_o = () => zurl.qs_parse(location.search.substr(1), {
    safe: true
  });

  const E = {};
  const ref = qs_o().ref || '';
  const useEffect = React.useEffect,
        useState = React.useState;
  E.all_plans = hopt.all_plans;
  E.all_plans_ids_map = {};
  (_E$all_plans = E.all_plans) === null || _E$all_plans === void 0 ? void 0 : _E$all_plans.forEach(p => E.all_plans_ids_map[p.id] = true);
  let fixed_plan_ids;
  let default_opt = {};
  let plus_util;
  let discount_plans = hopt.discount_plans || [];

  E.set_plus_util = _util => plus_util = _util;

  E.emitter = new events.EventEmitter();

  E.set_plans = plans => {
    var _E$all_plans2;

    E.all_plans = plans;
    E.all_plans_ids_map = {};
    (_E$all_plans2 = E.all_plans) === null || _E$all_plans2 === void 0 ? void 0 : _E$all_plans2.forEach(p => E.all_plans_ids_map[p.id] = true);
    E.emitter.emit('on_update_plans');
  };

  E.use_plans = () => {
    const _useState = useState(0),
          _useState2 = _slicedToArray(_useState, 2),
          refresh = _useState2[0],
          set_refresh = _useState2[1];

    useEffect(() => {
      const updater = () => set_refresh(count => count + 1);

      E.emitter.on('on_update_plans', updater);
      return () => E.emitter.removeListener('on_update_plans', updater);
    }, []);
    return refresh;
  };

  E.get_discount_plans = () => discount_plans;

  E.activate_discount_plans = (plans, base_plans = []) => {
    discount_plans = plans || [];

    var _iterator = _createForOfIteratorHelper(plans),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        const plan = _step.value;

        let _plan = E.all_plans.find(pl => pl.id == plan.id);

        if (!_plan) {
          _plan = Object.assign({}, plan);
          E.all_plans.push(_plan);
        }

        if (!_plan.base_plan) {
          var _iterator2 = _createForOfIteratorHelper(base_plans),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              const p = _step2.value;

              if (_plan.id == p.fallback_plan) {
                plan.base_plan = _plan.base_plan = p.id;
                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }

        if (!_plan.base_plan) {
          var _iterator3 = _createForOfIteratorHelper(base_plans),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              const p = _step3.value;

              if (_plan.period == p.period && _plan.type == p.type) {
                plan.base_plan = _plan.base_plan = p.id;
                break;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    E.emitter.emit('on_update_plans');
  };

  E.is_plan_discount = p => {
    if (!p) return false;
    let is_active_discount = false;

    if (discount_plans) {
      discount_plans.forEach(pl => {
        if (pl.id == p.id) is_active_discount = true;
      });
    }

    return is_active_discount;
  };

  E.get_valid_message = () => {
    if (!discount_plans.length) return 'The code you inserted is not valid';
    const plans_info = E.get_plans_info([discount_plans[0].id]);
    const plan = plans_info[Object.keys(plans_info)[0]];
    const name = plan.short_name + ' ' + zstring.capitalize(zmembership.type2name[plan.type] || '') + ' plan';
    return `The code you inserted is only valid for the ${name}`;
  };

  E.set_fixed_plan_ids = plans => fixed_plan_ids = plans;

  E.clear_fixed_plan_ids = () => fixed_plan_ids = null;

  E.set_plan_opt = _opt => default_opt = _opt;

  E.get_plan_ids = opt => {
    var _qs_plan_ids, _hopt$uninstall$plan_, _hopt$uninstall;

    const _opt = _objectSpread({}, opt) || _objectSpread({}, default_opt);

    if (fixed_plan_ids) return fixed_plan_ids;

    let _qs_o = qs_o(),
        fixed_id = _qs_o.fixed_id,
        qs_plan_ids = _qs_o.plan_ids;

    if (fixed_id) return [fixed_id];
    if (qs_plan_ids) qs_plan_ids = qs_plan_ids.split(' ').filter(p => E.all_plans_ids_map[p]);
    if ((_qs_plan_ids = qs_plan_ids) !== null && _qs_plan_ids !== void 0 && _qs_plan_ids.length) return qs_plan_ids;
    _opt.ultra = _opt.ultra || pages_dict.is_ultra_page();
    const is_plus_page = pages_dict.is_plus_page();
    const is_refund_promo = pages_dict.is_refund_exp();
    const annual_promo = pages_dict.is_uninstall_page() || pages_dict.is_annual_promo() || is_refund_promo;
    const annual_promo_full = pages_dict.is_annual_promo_full();
    let annual_promo_ids = (_hopt$uninstall$plan_ = (_hopt$uninstall = hopt.uninstall) === null || _hopt$uninstall === void 0 ? void 0 : _hopt$uninstall.plan_ids) !== null && _hopt$uninstall$plan_ !== void 0 ? _hopt$uninstall$plan_ : [];
    if (is_refund_promo) annual_promo_ids = hopt.refund_exp.plan_ids;
    let plan_ids = annual_promo && _opt.ultra ? hopt.annual_promo_ultra.plan_ids : _opt.ultra ? hopt.ultra.plan_ids : annual_promo_full ? hopt.annual_promo_full.plan_ids : annual_promo ? annual_promo_ids : is_plus_page ? hopt.join_plus.plan_ids : hopt.join_n.plan_ids;
    if (pages_dict.is_ni_get_hola()) plan_ids = hopt.ni_aff_plans.plan_ids;
    if (pages_dict.is_annual_get_hola()) plan_ids = hopt.annual_aff_plans.plan_ids;
    if (pages_dict.is_ultra_flash_special()) plan_ids = hopt.ultra_flash_special.plan_ids;
    if (ref == 'studentbeans') plan_ids.push('promo_y1', 'promo_y3');
    if (pages_dict.is_bogof_promo()) plan_ids = hopt.bogof_promo.plan_ids;
    if (pages_dict.is_kivoto_promo()) plan_ids = hopt.kivoto_promo.plan_ids;
    if (pages_dict.is_bogof_y_promo()) plan_ids = ['y12005_vd_promo'];
    if (pages_dict.is_dunning_promo()) plan_ids = hopt.dunning_promo.plan_ids;
    if (pages_dict.is_march_madness_promo_full()) plan_ids = hopt.mm_promo_full.plan_ids;else if (pages_dict.is_march_madness_promo()) plan_ids = hopt.mm_promo.plan_ids;
    return plan_ids;
  };

  E.get_base_discount = () => {
    if (pages_dict.is_ni_get_hola()) return hopt.ni_aff_plans.base_discount;
    if (pages_dict.is_annual_get_hola()) return hopt.annual_aff_plans.base_discount;
    return '';
  };

  E.get_discount_plan = pl => {
    if (pl && discount_plans) {
      const found = discount_plans.find(d_p => d_p.base_plan == pl.id);
      return found ? E.get_plan_info(found.id) : null;
    }

    return null;
  };

  const is_coupon_flow = () => ({
    '/join/stackcommerce': 1,
    '/join/groupon': 1
  })[location.pathname.toLowerCase()];

  E.get_coupon_flow = () => {
    if (ref == 'studentbeans') return 'promo_plan';
    if (is_coupon_flow()) return 'coupon';
  };

  E.merge_plans = (src, plans) => src.map(p => E.get_replaced_plan(p, plans).id);

  E.get_replaced_plan = (plan, plans) => {
    var _iterator4 = _createForOfIteratorHelper(plans),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        const p = _step4.value;
        if (plan.period == p.period) return p;
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }

    return plan;
  };

  const get_qs_plan_ids = () => {
    let ids = qs_o().plan_ids;
    if (!ids) return;
    ids = ids.split(' ').filter(p => E.all_plans_ids_map[p]);
    if (!ids.length) return;
    return ids;
  };

  const get_replace_plan = qs_plan_ids => !(qs_plan_ids || get_qs_plan_ids()) && plus_util && plus_util.plans_ab_test && plus_util.plans_ab_test.replace;

  E.get_plans_info = (ids, opt = {}) => {
    const plans_info = {};
    let qs_plan_ids = get_qs_plan_ids();
    ids = ids || qs_plan_ids || hopt.payment.plan_ids;
    const replace_plan = get_replace_plan(qs_plan_ids);
    const plans = common_ui.fill_plans_info(ids, E.all_plans, {
      discount_base: E.get_base_discount(),
      replace_plan
    });
    if (replace_plan) plans.sort((a, b) => a.day_price - b.day_price);
    plans.forEach((p, i) => {
      let id = p.period;
      if (plans_info[id]) id = id + '_' + i;
      plans_info[id] = p;
    });
    return plans_info;
  };

  E.get_plan_info = id => common_ui.fill_plans_info([id], E.all_plans, {
    replace_plan: get_replace_plan()
  })[0];

  E.is_plan = opt => opt.is_plan;

  E.get_plans_info_obj = (opt = {}) => {
    if (E.is_plan(opt)) return opt;
    let ids = E.get_plan_ids();
    if (opt.id == 'coupon') return {
      id: opt.id,
      price: 0
    };
    if (opt.id && !ids.includes(opt.id)) ids = [...ids, opt.id];
    const plans = E.get_plans_info(ids);

    const filtered = _filter(plans, opt).sort((a, b) => a.day_price - b.day_price);

    return filtered[0];
  };

  E.get_min_price_plan = plans => _.min_by(plans, p => p.day_price);

  E.get_special_plans = plans => {
    const best = E.get_min_price_plan(plans);
    const popular = plans.find(p => p.period == (best.period == '1 Y' ? '1 M' : '1 Y'));
    return {
      best,
      popular
    };
  };

  return E;
});